import React from 'react';

const ButtonFuctionDashboard = ({ Icon, onClick, bgColor = 'bg-[#2f313e]', borderColor = 'transparent' }) => {
  return (
    <button
      onClick={onClick}
      className={`w-7 h-7  ${bgColor} flex  items-center justify-center rounded-[8px] ${borderColor}`}
    >
      {Icon && <Icon className="h-4 w-4" alt="cripto wallet" />}
    </button>
  );
};

export default ButtonFuctionDashboard;
